import { render } from "./KanbanBlock.vue?vue&type=template&id=00787c2c&scoped=true&ts=true"
import script from "./KanbanBlock.vue?vue&type=script&lang=ts"
export * from "./KanbanBlock.vue?vue&type=script&lang=ts"

import "./KanbanBlock.vue?vue&type=style&index=0&id=00787c2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00787c2c"]])

export default __exports__